import { useEffect, useState } from "react";
import { useUpdateUserProfile } from "../hooks/useUpdateUserProfile";

export default function EditProfileModal({ authUser }) {
  const [formData, setFormData] = useState({
    fullname: "",
	username: "",
	email: "",
	link: "",
	newPassword: "",
	currentPassword: "",
  })

  const { updateProfile, isUpdating, error } = useUpdateUserProfile()

  const handleInputChange = (e) => {
	setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  useEffect(() => {
	if (authUser) {
	  setFormData({
		fullname: authUser?.fullname || '',
		username: authUser?.username || '',
		email: authUser?.email || '',
		link: authUser?.link || '',
		newPassword: "",
		currentPassword: "",
	  })
	}
  }, [authUser])

  return (
    <>
	  <button
		type='button'
		className='btn btn-violet rfs-5'
		data-bs-toggle='modal'
		data-bs-target='#editProfileModal'
	  >
		{isUpdating && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
		{!isUpdating && 'Edit profile'}
	  </button>

	  <div
		className='modal fade'
		id='editProfileModal'
		aria-labelledby='editProfileModalLabel'
		aria-hidden='true'
	  >
		<div className='modal-dialog' role="dialog">
		  <div className={`modal-content border ${error ? 'border-danger' : 'border-violet'} mx-auto`}>
		    <div className='modal-header'>
			  <span className='modal-title text-body rfs-2 ms-3 my-3' id='editProfileModalLabel'>Update Profile</span>
			  <button
			    type='button'
				className='btn-close me-2 rfs-5'
				data-bs-dismiss='modal'
				aria-label='Close'
			  ></button>
			</div>

			<div className='modal-body'>
			  <form
			  	className="p-4"
				onSubmit={(e) => {
				  e.preventDefault()
				  updateProfile(authUser?.id, formData)
				}}
			  >
				<div className="form-floating mb-3">
				  <input
					type="text"
					className={`form-control border rounded border-violet`}
					onChange={handleInputChange}
					//value={formData.fullname}
					id="floatingFullname"
					name="fullname"
					placeholder="Fullname"
				  />
				  <label htmlFor="floatingFullname">Fullname</label>
				</div>

				<div className="form-floating mb-3">
				  <input
					type="text"
					className={`form-control border rounded border-violet`}
					onChange={handleInputChange}
					//value={formData.username}
					id="floatingUsername"
					name="username"
					placeholder="Username"
				  />
				  <label htmlFor="floatingUsername">Username</label>
				</div>

				<div className="form-floating mb-3">
				  <input
					type="email"
					className={`form-control border rounded border-violet`}
					onChange={handleInputChange}
					//value={formData.email}
					id="floatingEmail"
					name="eamil"
					placeholder="Email"
				  />
				  <label htmlFor="floatingEmail">Email</label>
				</div>

				<div className="form-floating mb-3">
				  <input
					type="password"
					className={`form-control border rounded border-violet`}
					onChange={handleInputChange}
					//value={formData.currentPassword}
					id="floatingCurrentPassword"
					name="currentPassword"
					placeholder="Current Password"
				  />
				  <label htmlFor="floatingCurrentPassword">Current Password</label>
				</div>

				<div className="form-floating mb-3">
				  <input
					type="password"
					className={`form-control border rounded border-violet`}
					onChange={handleInputChange}
					//value={formData.newPassword}
					id="floatingNewPassword"
					name="newPassword"
					placeholder="New Password"
				  />
				  <label htmlFor="floatingNewPassword">New Password</label>
				</div>

				<div className="form-floating mb-3">
				  <input
					type="text"
					className={`form-control border rounded border-violet`}
					onChange={handleInputChange}
					//value={formData.link}
					id="floatingLink"
					name="link"
					placeholder="Link"
				  />
				  <label htmlFor="floatingLink">Link</label>
				</div>

				<div className="text-center mb-3">
				  <button className='btn btn-violet'>
				    {isUpdating && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
					{!isUpdating && 'Update'}
				  </button>
				</div>

				{error && <div className="shadow border rounded border-danger p-2 text-center text-danger">
				  <strong>{error}</strong>
				</div>}
			  </form>
			</div>
		  </div>
		</div>
	  </div>
    </>
  )
}
